import React from 'react';
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Outlet, Navigate } from 'react-router-dom';
import LoadingMessages from '../../components/LoadingMessages';
import Role  from '../../components/Role/Role';

const Invoices = () => {
    const { t } = useTranslation();

    const {
        isLoading,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.invoices);

    return (
        <div className="Invoices">
            <Role not has="admin">
                <Navigate to="/" />
            </Role>

            <LoadingMessages
                isLoading={ !!isLoading }
                hasError={ !!hasLoadingError }
                errorMessage={ loadingErrorMessage }
            />

            <Outlet />

        </div>
    );
}


export default Invoices;
